import React from 'react';
import Validation from '../Validation/Validation';
import ValidationStatus from '../Validation/ValidationStatus';

interface TextInputProps {
    id: string;
    value: string;
    rows: number;
    required: boolean;
    name: string;
    label: string;
    placeholder: string;
    multiline: boolean;
    disabled: boolean;
    onChange: (event: string) => void;
    type: string;
    validationStatus: string;
    ValidationMessage: string;
    maxLength: number;
    minLength: number;
    className: string;
}

//TODO: add icon support, add scrollbar
const TextInput: React.FC<Required<Pick<TextInputProps, 'onChange'>> & Partial<TextInputProps>> = ({
    id,
    value = '',
    rows,
    required,
    name,
    label,
    placeholder,
    multiline,
    disabled,
    onChange,
    type = 'text',
    validationStatus,
    ValidationMessage,
    maxLength,
    minLength,
    className
}) => {
    let input;

    if (multiline) {
        input = (
            <textarea
                autoComplete="off"
                value={value}
                rows={rows}
                wrap="soft"
                required={required}
                name={name}
                minLength={minLength}
                maxLength={maxLength}
                disabled={disabled}
                id={id}
                placeholder={placeholder}
                onChange={(e) => {
                    e.preventDefault();
                    onChange(e.target.value);
                }}
                className={`font-sf p-3 resize-none hover:border-sf-gray-400 focus:outline-none focus-visible:border-sf-primary-500 bg-white disabled:bg-sf-gray-200 rounded-lg placeholder:text-sf-gray-200 border border-sf-gray-200 h-20 w-50 text-sf-gray-800 text-13 ${className}`}
            />
        );
    } else {
        input = (
            <input
                autoComplete="off"
                value={value}
                required={required}
                name={name}
                minLength={minLength}
                maxLength={maxLength}
                disabled={disabled}
                id={id}
                placeholder={placeholder}
                type={type}
                onChange={(e) => {
                    e.preventDefault();
                    onChange(e.target.value);
                }}
                className={`font-sf px-3 hover:border-sf-gray-400 focus:outline-none focus-visible:border-sf-primary-500 bg-white rounded-lg placeholder:text-sf-gray-200 border border-sf-gray-200 h-10 w-50 text-sf-gray-800 text-13 ${className}`}
            />
        );
    }

    return (
        <>
            {label && <div className="h-4 text-13 text-gray-800 mb-1">{label}</div>}
            {input}
            {ValidationMessage && (
                <Validation
                    className="mt-0.5"
                    text={ValidationMessage}
                    showIcon={false}
                    validationStatus={validationStatus || ValidationStatus.Error}
                />
            )}
        </>
    );
};

export default TextInput;
